import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "../components/ui/card";
import { Button } from "../components/ui/button";

export default function Sponsors() {
  const sponsors = [
    {
      title: "Emergent",
      subtext: "Build amazing apps in minutes with a production-ready AI engineering agent.",
      href: "https://app.emergent.sh/?via=junian",
      cta: "Try Emergent Now (affiliate link)",
    },
    // Add more sponsors here easily
  ];

  const trackAffiliateClick = (s) => {
    try {
      if (window && window.posthog && typeof window.posthog.capture === "function") {
        window.posthog.capture("affiliate_click", {
          source: "sponsors_page",
          partner: s.title,
          link_url: s.href,
        });
      }
    } catch (e) {
      // no-op if analytics are unavailable
    }
  };

  return (
    <div className="mx-auto max-w-3xl px-4 py-6 sm:py-10">
      <Card className="border-0 shadow-none bg-transparent">
        <CardHeader>
          <CardTitle className="text-slate-900 dark:text-slate-100">Our Sponsors</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="grid gap-4">
            {sponsors.map((s, i) => (
              <div key={i} className="brand-gradient with-shapes rounded-xl p-4 sm:p-6">
                <div className="text-base sm:text-lg font-semibold text-slate-900 dark:text-slate-100">{s.title}</div>
                <div className="mt-1 text-sm sm:text-base text-slate-700 dark:text-slate-300">{s.subtext}</div>
                <div className="mt-4">
                  <Button asChild className="btn-primary">
                    <a
                      href={s.href}
                      target="_blank"
                      rel="sponsored noopener noreferrer"
                      aria-label={`Visit ${s.title}`}
                      onClick={() => trackAffiliateClick(s)}
                      onAuxClick={() => trackAffiliateClick(s)}
                    >
                      {s.cta}
                    </a>
                  </Button>
                </div>
                <p className="mt-3 text-xs sm:text-[13px] leading-relaxed text-slate-700/90 dark:text-slate-300/90">
                  Disclosure: This is an affiliate link. If you sign up, we may earn a small commission at no extra cost to you. Thank you for supporting this free course.
                </p>
              </div>
            ))}
          </div>
        </CardContent>
      </Card>
    </div>
  );
}